import { JsonSchema, Tester, TesterContext, UISchemaElement } from '@jsonforms/core';
import { UiSchema, UiSchemaElement } from './testerUtils';

const getCustomComponent = (context: TesterContext, schema: JsonSchema, uischema: UISchemaElement) => {
  const property = (uischema as { scope?: string }).scope?.split('/').pop();

  if (!property) {
    return null;
  }

  const child = schema.properties?.[property];

  if (!child) {
    return null;
  }

  const uiSchema = context.config.uischema as UiSchema;
  return uiSchema.find((element: UiSchemaElement) => element.settingid === (child as { settingid: string }).settingid);
};

export const hasCustomComponent: (component: 'color-picker' | 'oneof-select' | 'hidden') => Tester =
  (component) => (uiSchema, schema, context) => {
    const customUiSchema = getCustomComponent(context, schema, uiSchema);

    if (customUiSchema?.component === component) {
      return true;
    }

    return false;
  };
